export enum DocumentTagCategory {
  Predefined = 'predefined',
}

export enum TagSelectorAction {
  Back = 'back',
}

export enum TagErrorEnum {
  tagExists = 'tagExists',
  tagChars = 'tagChars',
}
